import { useContext } from 'react';
import { useLocalStore } from 'mobx-react';
import { useConfig } from '@ibe/components';
import CmsHotelService from '../Services/CmsHotelService';
import CmsHotelContext from '../Contexts/CmsHotelContext';

function useCmsHotel(): CmsHotelService {
  const context = useContext(CmsHotelContext);
  const config = useConfig();
  const cmsService: CmsHotelService = useLocalStore<CmsHotelService>(() => context);

  cmsService.apiUrl = config.apiUrl;

  return cmsService;
}

export default useCmsHotel;
